export function debounce(f, { delay } = { delay: 300 }) {
    let timeoutId = null;
    return (...args) => {
        if (timeoutId) {
            clearTimeout(timeoutId);
            timeoutId = null;
        }
        timeoutId = setTimeout(() => f(...args), delay);
    };
}
